import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Box, Grid, Typography } from '@material-ui/core';

import { setReloadPopup } from '../../../state/app/appActions';
import consts from '../../../main/consts';

const useStyles = makeStyles((theme) => ({
  listContent: {
    borderBottom: `1px solid ${grey[200]}`,
    borderTop: `1px solid ${grey[200]}`,
    maxHeight: '50vh',
    minWidth: 380,
    height: 130,
  },
  title: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
  },
  text: {
    height: '100%',
  },
  spacingBottom: {
    marginBottom: 10,
  },
  action: {
    padding: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

export default function ReloadPopup(props) {
  const { open, version } = useSelector(state => state.app.reloadPopup);
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = () => () => {
    dispatch(setReloadPopup(false, version));
    window.location.reload();
  }

  return (
    <>
      <Dialog open={process.env.NODE_ENV === 'production' && open}>
        <DialogTitle className={classes.title}>Atenção</DialogTitle>

        <DialogContent className={classes.listContent}>
          <Grid container direction="column" justify="space-between" alignItems="center" className={classes.text}>
            <Grid item>
              <Typography>Existe uma nova versão disponível!</Typography>
            </Grid>
            <Grid item>
              <Typography>Versão atual: {consts.APP_VERSION}</Typography>
              <Typography>Versão disponível: {version}</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.action}>
          <Box flexGrow={1} display="flex" justifyContent="center" p={0}>
            <Box>
              <Button onClick={handleClose(true)} color="primary" variant="contained">Atualizar</Button>
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  )
}
